import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SecurityService } from "@tylertech/core-module";
import { Leaf, OnContextEvent, Tree, TreeNode } from "./tree";

@Component({
    selector: "metadata-navigation-tree",
    templateUrl: "./metadataNavigationTree.tmpl.html",
    standalone: false
})
export class MetadataNavigationTreeComponent implements OnInit
{
    @Input()
    readonly nodes: ReadonlyArray<TreeNode>;

    @Input()
    public readonly isChild: boolean = false;

    @Output() public onClick = new EventEmitter<string>();

    @Output() public onContextMenu = new EventEmitter<OnContextEvent>();

    private compactMode: boolean = false;


    constructor(
        private readonly $securityService: SecurityService
    ) { }

    ngOnInit(): void
    {
        this.compactMode = this.$securityService.IsCompactMode;
    }

    isLeaf(node: TreeNode): boolean
    {
        return Leaf.isLeaf(node);
    }

    toggleNode(node: Tree): void
    {
        node.expanded = !node.expanded;
    }

    isExpanded(node: Tree): boolean
    {
        return node.expanded;
    }

    getToggleClass(node: Tree): Record<string, boolean>
    {
        // TODO - these classes are defined in library/search, are we properly dependent on that module here??????
        return {
            "filter-icon-expand": node.expanded,
            "filter-icon-collapse": !node.expanded,
        };
    }

    select(id: string): void
    {
        this.onClick.emit(id);
    }

    context(event: OnContextEvent): void
    {
        this.onContextMenu.emit(event);
    }

    trackById(_index: number, node: TreeNode): string
    {
        return node.id;
    }
}
